import React, { useState } from "react";
import Rating from "./Rating";

const RatingExample: React.FC = () => {
	const [interactiveRating, setInteractiveRating] = useState(3);

	return (
		<div className="space-y-8">
			<div>
				<h3 className="text-lg font-semibold mb-4">Rating Component Examples</h3>

				<div className="space-y-6">
					{/* Basic readonly rating */}
					<div>
						<h4 className="text-md font-medium mb-2">Readonly Rating (4.5 stars)</h4>
						<Rating initialValue={4.5} readonly fillColor="#4BB769" size={24} />
					</div>

					{/* Interactive rating */}
					<div>
						<h4 className="text-md font-medium mb-2">Interactive Rating</h4>
						<Rating
							initialValue={interactiveRating}
							onChange={setInteractiveRating}
							fillColor="#ffc107"
							size={32}
						/>
						<p className="text-sm text-gray-600 mt-2">Current rating: {interactiveRating}</p>
					</div>

					{/* Small readonly ratings */}
					<div>
						<h4 className="text-md font-medium mb-2">Small Readonly Ratings</h4>
						<div className="space-y-2">
							<div className="flex items-center gap-3">
								<span className="text-sm w-24">Performance:</span>
								<Rating initialValue={4.2} readonly fillColor="#4BB769" size={20} />
								<span className="text-sm text-gray-600">4.2/5</span>
							</div>
							<div className="flex items-center gap-3">
								<span className="text-sm w-24">Punctuality:</span>
								<Rating initialValue={3.8} readonly fillColor="#4BB769" size={20} />
								<span className="text-sm text-gray-600">3.8/5</span>
							</div>
						</div>
					</div>

					{/* Different colors */}
					<div>
						<h4 className="text-md font-medium mb-2">Different Colors</h4>
						<div className="space-y-2">
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Gold:</span>
								<Rating initialValue={4} readonly fillColor="#ffc107" size={24} />
							</div>
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Green:</span>
								<Rating initialValue={4} readonly fillColor="#4BB769" size={24} />
							</div>
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Blue:</span>
								<Rating initialValue={4} readonly fillColor="#219CD0" size={24} />
							</div>
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Red:</span>
								<Rating initialValue={4} readonly fillColor="#e53e3e" size={24} />
							</div>
						</div>
					</div>

					{/* Different sizes */}
					<div>
						<h4 className="text-md font-medium mb-2">Different Sizes</h4>
						<div className="space-y-2">
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Small:</span>
								<Rating initialValue={3.5} readonly fillColor="#ffc107" size={16} />
							</div>
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Medium:</span>
								<Rating initialValue={3.5} readonly fillColor="#ffc107" size={24} />
							</div>
							<div className="flex items-center gap-3">
								<span className="text-sm w-16">Large:</span>
								<Rating initialValue={3.5} readonly fillColor="#ffc107" size={32} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RatingExample;
